// extracted by mini-css-extract-plugin
export default {"container":"md_message_container__wBNm2","quotation_container":"md_message_quotation_container__Fh96h","top_container":"md_message_top_container__jkSx8"};